import { walletStore } from './wallet.model';
// eslint-disable-next-line
export default { walletStore };
